var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSellerPersonOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0 0.345703)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21.3457C3.44772 21.3457 3 20.898 3 20.3457V18.9082C3 17.2832 3.83125 15.9707 5.49375 14.9707C7.15625 13.9707 9.325 13.4707 12 13.4707C14.7 13.4707 16.875 13.9707 18.525 14.9707C20.175 15.9707 21 17.2832 21 18.9082V20.3457C21 20.898 20.5523 21.3457 20 21.3457H4ZM12 15.7207C10 15.7207 8.375 16.0207 7.125 16.6207C5.875 17.2207 5.25 17.9832 5.25 18.9082V19.0957H18.75V18.8707C18.75 17.9707 18.1312 17.2207 16.8937 16.6207C15.6562 16.0207 14.025 15.7207 12 15.7207ZM12 12.3457C10.75 12.3457 9.6875 11.9082 8.8125 11.0332C7.9375 10.1582 7.5 9.0957 7.5 7.8457C7.5 6.5707 7.9375 5.50195 8.8125 4.63945C9.6875 3.77695 10.75 3.3457 12 3.3457C13.275 3.3457 14.3437 3.77695 15.2062 4.63945C16.0687 5.50195 16.5 6.5707 16.5 7.8457C16.5 9.0957 16.0687 10.1582 15.2062 11.0332C14.3437 11.9082 13.275 12.3457 12 12.3457ZM12 5.5957C11.375 5.5957 10.8438 5.8082 10.4062 6.2332C9.96875 6.6582 9.75 7.1957 9.75 7.8457C9.75 8.4707 9.96875 9.00195 10.4062 9.43945C10.8438 9.87695 11.375 10.0957 12 10.0957C12.65 10.0957 13.1875 9.87695 13.6125 9.43945C14.0375 9.00195 14.25 8.4707 14.25 7.8457C14.25 7.1957 14.0375 6.6582 13.6125 6.2332C13.1875 5.8082 12.65 5.5957 12 5.5957Z",
    fill: "#212B36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSellerPersonOutline);
export default __webpack_public_path__ + "static/media/ico-seller-person-outline.b97e5c81af47d11a2e996cb7a504d51b.svg";
export { ForwardRef as ReactComponent };